import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { getRedirectUrl, isTopLevelWindow, readTimelineSettings } from './timelineSettings';

const redirectUrl = getRedirectUrl(
  readTimelineSettings(),
  isTopLevelWindow(),
  window.location.href
);

if (redirectUrl) {
  window.location.replace(redirectUrl);
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('timeline-root'),
  () => {
      var root = document.getElementById('timeline-root');
			window.parent.postMessage(root?.offsetHeight, "*");
  }
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
